export default __webpack_public_path__ + "resources/icons/d412-1c9f.webp";